{
  "queryName": "messages",
  "queryParam": null,
  "fields": ["id", "message", "updatedAt", "createdAt"]
}
